import { GeneralService } from './../services/general.service';
import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coacherr',
  templateUrl: './coacherr.component.html',
  styleUrls: ['./coacherr.component.css']
})
export class CoacherrComponent implements OnInit {

  
  constructor(private commonScriptComponent:CommonScriptComponent, private generalService:GeneralService) { }
  base_url = this.generalService.BASE_URL;
  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/coacherr/coacherr.component.ts